import React from 'react';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
  steps: string[];
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="w-full max-w-3xl mx-auto px-4 py-6">
      {/* 進度條 */}
      <div className="relative">
        {/* 背景線 */}
        <div className="absolute top-5 left-0 right-0 h-1 bg-gray-200 dark:bg-slate-700">
          {/* 已完成部分 */}
          <div
            className="h-full bg-brand-600 dark:bg-brand-500 transition-all duration-300"
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          />
        </div>

        {/* 步驟點和標籤 */}
        <div className="relative flex justify-between">
          {steps.map((step, index) => {
            const stepNumber = index + 1;
            const isCompleted = stepNumber < currentStep;
            const isCurrent = stepNumber === currentStep;
            const isUpcoming = stepNumber > currentStep;

            return (
              <div key={index} className="flex flex-col items-center">
                {/* 圓點 */}
                <div
                  className={`
                    w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm
                    transition-all duration-300
                    ${
                      isCompleted
                        ? 'bg-brand-600 dark:bg-brand-500 text-white'
                        : isCurrent
                        ? 'bg-brand-600 dark:bg-brand-500 text-white ring-4 ring-brand-200 dark:ring-brand-800'
                        : 'bg-gray-200 dark:bg-slate-700 text-gray-500 dark:text-gray-400'
                    }
                  `}
                >
                  {isCompleted ? (
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  ) : (
                    stepNumber
                  )}
                </div>

                {/* 標籤 */}
                <div
                  className={`
                    mt-2 text-xs font-medium text-center
                    transition-colors duration-300
                    ${
                      isCurrent
                        ? 'text-brand-600 dark:text-brand-400'
                        : 'text-gray-500 dark:text-gray-400'
                    }
                  `}
                >
                  {step}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
